import { render, staticRenderFns } from "./ConfirmationCode.vue?vue&type=template&id=eb2422e2&scoped=true"
import script from "./ConfirmationCode.vue?vue&type=script&lang=js"
export * from "./ConfirmationCode.vue?vue&type=script&lang=js"
import style0 from "./ConfirmationCode.vue?vue&type=style&index=0&id=eb2422e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb2422e2",
  null
  
)

export default component.exports